const _ = require('lodash');
const moment = require('moment');


export default class BaseModel {

  constructor(data) {
    this.populate(data);
  }

  populate(data) {
    Object.assign(this, data);
    this.validate();
  }

  validate() {
    // optional.  to be overridden in child class implementations as needed.
  }

  toPublishedData() {
    return _.toPlainObject(this);
  }

  _convertToBoolean(str) {
    return !!(_.toString(str) === '1');
  }

  _convertBooleanToBooleanString(value) {
    return (!!value)? '1': '0';
  }

  _convertToInteger(str, defaultValue = null) {
    let value = defaultValue;
    if (str !== null && str !== undefined) {
      let tmpValue = _.parseInt(str);
      if (_.isFinite(tmpValue)) {
        value = tmpValue;
      }
    }
    return value;
  }

  _convertIntegerToIntegerString(value, defaultValue = null) {
    return _.isFinite(value)? _.toString(value): defaultValue;
  }

  _convertToPositiveInteger(str, defaultValue = null) {
    let value = this._convertToInteger(str, 0);
    return (value > 0)? value: defaultValue;
  }

  _convertPositiveIntegerToIntegerString(value, defaultValue = null) {
    return (value > 0)? _.toString(value): defaultValue;
  }

  _convertToMomentValue(dateStr) {
    let retval = null;
    if (dateStr) {
      try {
        retval = moment(dateStr, ['YYYY-MM-DD', 'MM/DD/YYYY', 'M/DD/YYYY', 'M/D/YYYY']);
      } catch (ex) {}
    }
    return retval;
  }

  _convertToDateString(value, format = 'YYYY-MM-DD') {
    let datestr = null;
    if (value && value) {
      if (value && value.isValid()) {
        datestr = value.format(format);   // iso date only (no time)
      }
    }
    return datestr;
  }

  _convertDelimitedStringToStringList(str, delim = ',') {
    if (!str || _.isEmpty(str)) { str = ''; }
    return _.chain(str)
      .split(delim)
      .map(_.trim)
      .uniq()
      .compact()
      .value()
  }

  _convertStringListToDelimitedString(items, delim = ',') {
    if (!items || _.isEmpty(items)) { items = []; }
    return _.chain(items)
      .map(_.trim)
      .uniq()
      .compact()
      .join(delim)
      .value()
  }

}

